import { Button, Card, CardActions, CardContent, CardHeader, Divider, FormControl, InputLabel, Modal, TextField, Typography } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import axios from 'src/utils/axios';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  actions: {
    justifyContent: 'flex-end'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  fieldsComboDegisim: {
    margin: theme.spacing(0),
    display: 'flex',
  }
}));
function BarkodPopupModal({ open, onClose, className, FisNo, readonly, tasks }) {
  const classes = useStyles();
  const [UdgNeden30Gun, setUdgNeden30Gun] = useState([]);
  const [UdgNeden30GunValue, setUdgNeden30GunValue] = useState(0);
  const [digerAciklama, setDigerAciklama] = useState('');

  let DegisimData = readonly ? tasks.tasks.filter(d => parseInt(d.FisNo) === parseInt(FisNo)) : loadBaslandiJob();

  if (!readonly && (!DegisimData || DegisimData.length === 0)) {
    const current = tasks?.tasks?.find(d => Number(d.FisNo) === Number(FisNo) && Number(d.DurumKodu) === 33);
    if (current) {
      saveBaslandiJob(current);
      DegisimData = loadBaslandiJob();
    }
  }

  const GetArtemisUdg30GunNeden = () => {
    axios.get(`/GetArtemisUdg30GunNeden`)
      .then(response => {
        if (response.data.length > 0) {
          setUdgNeden30Gun(response.data);
        }
      })
  }


  useEffect(() => {

    if (DegisimData === undefined || DegisimData[0] === undefined) {
      return;
    }
    GetArtemisUdg30GunNeden();
  }, [DegisimData]);


  const handleChange30GunDegisimNedeni = (e) => {
    setUdgNeden30GunValue(e.target.value || 0);
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_459_IADE_NEDEN: e.target.value || 0,
    };
    saveBaslandiJob(job);
  }
  const handleChange30GunDegisimNedeniAciklama = (e) => {
    setDigerAciklama(e.target.value || '');
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      UDS_459_IADE_NEDEN_ACIKLAMA: e.target.value || '',
    };
    saveBaslandiJob(job);
  }

  return (
    <Modal
      onClose={onClose}
      open={open}
    >
      <Card
        className={clsx(classes.root, className)}
      >
        <CardHeader title={"Ürün Değişim"} />
        <Divider />
        <CardContent className={classes.content}>
          <Divider className={classes.dividerDegisim} />
          <Typography className={classes.title} color="textSecondary">
            459-İlk 30 günde koşulsuz iade hizmetini seçtiniz. Lütfen iade nedenini seçiniz!.
          </Typography>
          <br />
          <Typography variant="h6" component="h2" gutterBottom>
            <FormControl variant="outlined" className={classes.fieldsComboDegisim}>
              <InputLabel id="demo-simple-select-outlined-label" >{'30 Gün Degisim Nedeni'}</InputLabel>
              <Select
                native
                onChange={handleChange30GunDegisimNedeni}
                label="Değişim Nedeni"
                fullWidth
                display='flex'
                value={UdgNeden30GunValue}
                labelId="degisimNeden_label"
                inputProps={{
                  name: "degisimNeden_select",
                  id: "degisimNeden_select"
                }}
              >
                <option value="0" defaultValue="0"></option>
                {UdgNeden30Gun.map(p => {
                  return <option key={p.ID} value={p.ID}>{p.ACIKLAMA}</option>
                })}
              </Select>
            </FormControl>
          </Typography>
          {
            UdgNeden30GunValue === 11 ? (
              <Typography variant="h6" component="h2" gutterBottom>
                <TextField
                  size="small"
                  id="desc"
                  autoComplete="no"
                  multiline
                  rows={2}
                  value={digerAciklama}
                  onChange={handleChange30GunDegisimNedeniAciklama}
                  fullWidth
                  label={'Diğer...Açıklama giriniz!'}
                  variant="outlined"
                />
              </Typography>
            )
              : null
          }
        </CardContent>
        <CardActions className={classes.actions}>
          <Button
            variant="contained"
            color="secondary"
            onClick={onClose}
            endIcon={<CloseIcon>Close</CloseIcon>}
            disabled={digerAciklama.length === 0 && UdgNeden30GunValue === 5}>
            Kapat
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

BarkodPopupModal.propTypes = {
  className: PropTypes.string,
  customer: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

BarkodPopupModal.defaultProps = {
  open: false,
  onClose: () => { }
};

export default BarkodPopupModal;
